<div class="mb-3 border-0">
  <div
    class="card d-flex flex-row border rounded-2 shadow-sm overflow-hidden"
    style="min-height: 100px"
  >
    <div
      class="d-flex align-items-center justify-content-center flex-shrink-0 text-white"
      style="width: 60px"
      [ngClass]="note.read ? 'bg-success' : 'bg-primary'"
    >
      <it-icon [name]="'check'" [color]="'light'"></it-icon>
    </div>

    <div class="flex-grow-1 d-flex flex-row p-3">
      <div class="flex-grow-1 d-flex flex-column justify-content-between">
        <div>
          <div class="fw-semibold">{{ note.type.name }}</div>
          <div *ngIf="note.title" class="text-muted small mb-2">
            {{ note.title }}
          </div>
          <div class="mb-2">{{ note.text }}</div>
        </div>

        <div class="text-muted small">
          Inserito da:
          <span class="fw-semibold"
            >{{ note.insertUser.name }} {{ note.insertUser.surname }}</span
          >
          | Il:
          <span class="fw-semibold">{{
            note.insertDate | date : "dd/MM/yyyy HH:mm"
          }}</span>
        </div>

        <div *ngIf="note.read && note.readUser" class="text-muted small">
          Letta da:
          <span class="fw-semibold"
            >{{ note.readUser.name }} {{ note.readUser.surname }}</span
          >
          | Il:
          <span class="fw-semibold">{{
            note.readDate | date : "dd/MM/yyyy HH:mm"
          }}</span>
        </div>
      </div>

      <div class="d-flex align-items-center ps-3" *ngIf="!note.read && !authService.isOperatoreSuperUser">
        <button
          [itButton]="'outline-primary'"
          [size]="'xs'"
          (click)="setNotificationRead()"
        >
          Contrassegna come letta
        </button>
      </div>
    </div>
  </div>
</div>
